// The layer tokens as numbers, for a library that takes its z-index as one rather than as CSS (react-joyride).
import { getTheme, themeOf } from './themes';

/** A layer token's z-index in the set in use, as the page has it: layerIndex('lureo-layer-tour') is 10000 in Lureo Light. */
export function layerIndex(name: 'lureo-layer-bar' | 'lureo-layer-overlay' | 'lureo-layer-tooltip' | 'lureo-layer-blocker' | 'lureo-layer-tour' | 'lureo-layer-toast'): number {
  return Number(themeOf(getTheme()).tokens[name]);
}
